import connect from '@elab/core/store/connect';
import { Form } from '@elab/components/connected/forms/Form';

import { createDispatcher } from '../GenericForm';

import { createActions, createReducer, createSagaFor, getTypes } from './redux';

const digitalStore = 'digital-loyalty-card';
const physicalStore = 'physical-loyalty-card';

const mapDigitalStateToProps = () => ({ storeName: digitalStore, emulateSlots: true });
const mapPhysicalStateToProps = () => ({ storeName: physicalStore, emulateSlots: true });

const mapDigitalDispatchToEvents = createDispatcher({
    storeName: digitalStore,
    reducers: createReducer(digitalStore),
    sagaFactory: createSagaFor(digitalStore),
    actions: createActions(digitalStore),
    types: getTypes(digitalStore),
});

const mapPhysicalDispatchToEvents = createDispatcher({
    storeName: physicalStore,
    reducers: createReducer(physicalStore),
    sagaFactory: createSagaFor(physicalStore),
    actions: createActions(physicalStore),
    types: getTypes(physicalStore),
});

export default () => {
    customElements.define(
        'e2-digital-card-form',
        connect(mapDigitalStateToProps, mapDigitalDispatchToEvents)(Form),
    );

    customElements.define(
        'e2-physical-card-form',
        connect(mapPhysicalStateToProps, mapPhysicalDispatchToEvents)(Form),
    );
};
